import { useRef } from "react";
import { createFailure, validationFailed, ValidationResult, validationSuccessful } from "sprint-common-web";

import { LINK_TOKEN } from "./common/linkToken";

export const useInviteToDeliveryBucketForm = () => {
    const abortController = useRef<AbortController>(new AbortController());

    const validateBody = async (body: string): Promise<ValidationResult> => {
        abortController.current.abort();
        abortController.current = new AbortController();

        if (!body.includes(LINK_TOKEN)) {
            const failure = createFailure(`Token '${LINK_TOKEN}' should be used`, "email.LinkToken");

            return validationFailed([failure]);
        }

        return validationSuccessful();
    };

    return {
        validateBody
    };
};
